
<script>
  export let value; 
</script>

<textarea bind:value={value}/>

<style>
  textarea {
    width: 100%;
    height: 500px;
  }
</style>